/**
 * Route for `reddit-ads-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RedditAdsIntegrationPage } from "../features/reddit-ads-integration/RedditAdsIntegrationPage";

export const redditAdsIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/reddit-ads-integration",
	component: RedditAdsIntegrationPage,
});

export default redditAdsIntegrationRoute;
